var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControl, FormHelperText, InputAdornment } from '@mui/material';
import useInputDebounce from '../../hooks/useInputDebounce';
import InputBaseOutlinedInput from './InputBase.OutlinedInput';
import InputBaseUnderlineInput from './InputBase.UnderlineInput';
export default function InputBase(props) {
    var _a = props.controlled, controlled = _a === void 0 ? false : _a, _b = props.variant, variant = _b === void 0 ? 'outlined' : _b, onChange = props.onChange, format = props.format, value = props.value, helperText = props.helperText, _c = props.error, error = _c === void 0 ? false : _c, _d = props.fullWidth, fullWidth = _d === void 0 ? false : _d, _e = props.size, size = _e === void 0 ? 'small' : _e;
    var startAdornment = props.startAdornment, endAdornment = props.endAdornment;
    var _f = useInputDebounce({ initialValue: value, onChange: onChange, format: format, controlled: controlled }), inputValue = _f.inputValue, onInputChange = _f.onInputChange;
    var inputStyle = {};
    if ((startAdornment === null || startAdornment === void 0 ? void 0 : startAdornment.type) === InputAdornment) {
        inputStyle = { paddingLeft: 8 };
    }
    else if (startAdornment) {
        startAdornment = _jsx(InputAdornment, __assign({ position: "start" }, { children: startAdornment }));
        inputStyle = { paddingLeft: 0 };
    }
    if ((endAdornment === null || endAdornment === void 0 ? void 0 : endAdornment.type) === InputAdornment) {
        inputStyle = { paddingRight: 8 };
    }
    else if (endAdornment) {
        endAdornment = _jsx(InputAdornment, __assign({ position: "end" }, { children: endAdornment }));
        inputStyle = { paddingRight: 0 };
    }
    var labelSize = size === 'medium' ? 'normal' : size;
    var isUnderline = variant === 'underline';
    var inputProps = __assign(__assign({}, props), { onChange: onInputChange, value: inputValue, endAdornment: endAdornment, startAdornment: startAdornment, labelSize: labelSize, inputStyle: inputStyle });
    return (_jsxs(FormControl, __assign({ size: size, 
        // variant={variant}
        fullWidth: fullWidth }, { children: [isUnderline && _jsx(InputBaseUnderlineInput, __assign({}, inputProps)), !isUnderline && _jsx(InputBaseOutlinedInput, __assign({}, inputProps)), helperText && _jsx(FormHelperText, __assign({ error: error }, { children: helperText }))] })));
}
